export const setCSSVariable = (name, value, querySelector = ':root') => {
  const variableName = `--${name}`;
  const elem = document.querySelector(querySelector);
  const elemStyles = getComputedStyle(elem);
  const oldValue = elemStyles.getPropertyValue(variableName);

  elem.style.setProperty(variableName, value);

  return () => {
    elem.style.setProperty(variableName, oldValue);
  };
};

export const setFontCSSVariables = (fontName) => {
  setCSSVariable('font-f', fontName);
  setCSSVariable('font-f-regular', `${fontName} regular`);
  setCSSVariable('font-f-bold', `${fontName} bold`);
  setCSSVariable('font-f-semibold', `${fontName} semibold`);
};
